import { getCookie } from "cookies-next";
import { getSession } from "next-auth/react";
import { CookieNameEnum } from "../constants/cookie-names";

/** Chama o ``next-auth``, obtendo o accessToken do usuário. */
export async function getUserToken() {
    const userTokensCookie = getCookie(CookieNameEnum.UserAccessTokens)

    if (userTokensCookie) {
        const userTokens = JSON.parse(userTokensCookie as string)

        if (userTokens?.accessToken) {
            return userTokens.accessToken as string
        }
    }

    let accessToken: string = ''

    try {
        const data = await getSession() // Chama o jwt na api/auth/[...nextauth], que posteriormente chama session.

        if (data?.accessToken) {
            accessToken = data.accessToken
        }
        else {
            console.warn("Não foi possível obter o accessToken do usuário.")

            if (data?.error)
                console.error(data.error)
        }
    }
    catch (e) {
        console.error(e)
    }

    return accessToken
}